import { getLDFlags } from "@lululemon/ecom-core";
import * as cache from "@lululemon/ecom-common/src/services/cache";
import { setRecentlyViewedProductData } from "@lululemon/ecom-common/src/lib/tile-utils";

import { loadData } from "../../logic/loadData.logic";
import { getDataUrl } from "../../utils/url";
import { setLoadedInseams } from "./product-detail-page";

/*
 * NOTE: these actions are being deprecated
 * in favour of productDetailPage - see product-detail-page.js
 */

export const SET_DELIVERY_TYPE = "SET_DELIVERY_TYPE";
export const SELECT_COLOR = "SELECT_COLOR";
export const SET_SHOW_NO_SIZE_SELECTED_WARNING =
  "SET_SHOW_NO_SIZE_SELECTED_WARNING";
export const SET_HOOK_CACHE_VALUES = "SET_HOOK_CACHE_VALUES";
export const SET_PRODUCT = "SET_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const SET_PDP_CONTENTFUL_DATA = "SET_PDP_CONTENTFUL_DATA";
export const SET_OUTFIT_AVAILABLE = "SET_OUTFIT_AVAILABLE";
export const SET_CHANGE_MODEL_COLORWAYS_MEDIA_INFO =
  "SET_CHANGE_MODEL_COLORWAYS_MEDIA_INFO";
export const SET_GIFT_CARD_TOTAL_AMOUNT = "SET_GIFT_CARD_TOTAL_AMOUNT";
export const SET_GIFT_CARD_ERROR = "SET_GIFT_CARD_ERROR";

export function selectColor(data) {
  return (dispatch) => {
    dispatch({
      type: SELECT_COLOR,
      data,
    });
  };
}

export function setDeliveryType(deliveryType) {
  return (dispatch) => {
    dispatch({
      type: SET_DELIVERY_TYPE,
      payload: deliveryType,
    });
  };
}

export const setHooksCacheValues = (cacheValues) => (dispatch) => {
  dispatch({
    type: SET_HOOK_CACHE_VALUES,
    payload: cacheValues,
  });
};

export const setShowNoSizeSelectedWarning = (payload) => (dispatch) => {
  dispatch({
    type: SET_SHOW_NO_SIZE_SELECTED_WARNING,
    payload,
  });
};

export function setProduct(
  data,
  queryString,
  path = "",
  colorCode = undefined,
  { graphqlClient, locale } = {}
) {
  const { data: productData } = data;
  setRecentlyViewedProductData(productData, colorCode, locale);
  return (dispatch) => {
    dispatch({
      type: SET_PRODUCT,
      path,
      data,
      queryString,
    });
    if (graphqlClient) {
      dispatch(prefetchVariants(graphqlClient, locale));
    }
  };
}

const inFlightRequests = {};

export function prefetchVariants(graphqlClient, locale) {
  return async function (dispatch, getState) {
    if (typeof window === "undefined") {
      return Promise.reject("The preloader must be run in the browser!");
    }

    const ldFlags = await getLDFlags({ fetch });
    const state = getState?.() || {};
    const pages = state?.rootReducer?.pages || {};
    const pageCacheKey = getDataUrl(
      window.location.pathname.replace(`/${locale?.toLowerCase()}/`, "/")
    );
    const pagesMap = new Map(Object.entries(pages));
    const productData = pagesMap.get(pageCacheKey)?.data?.productDetailPageData;
    const inseams = productData?.allInseam || [];
    const variants = productData?.productVariants || [];
    const productId = productData?.productSummary?.productId;

    const allVariants = [
      ...inseams.map((inseam) => ({
        path: inseam.productUrl,
        label: inseam.inseam,
        productId: inseam.productId,
        isInseam: true,
      })),
      ...variants.filter(
        (variant) =>
          !inseams.find((inseam) => inseam.productId === variant.productId)
      ),
    ];
    const linkedProducts = allVariants.filter(
      (variant) => variant.productId !== productId && !!variant.path
    );
    if (linkedProducts.length) {
      // preload data for linked products
      const loadInseamPromises = [];
      linkedProducts.forEach((variant) => {
        const dataUrl = getDataUrl(variant.path);
        if (
          cache.isPageDataStale(pages, dataUrl) &&
          !inFlightRequests[dataUrl]
        ) {
          const loadPromise = loadData(
            variant.path,
            "",
            graphqlClient,
            dispatch,
            {
              isPreload: true,
              nextLocale: locale?.toLowerCase(),
              ldFlags,
            }
          );
          if (variant.isInseam) {
            loadInseamPromises.push(loadPromise);
          }
          loadPromise.finally(() => {
            delete inFlightRequests[dataUrl];
          });
          inFlightRequests[dataUrl] = true;
        }
      });

      setLoadedInseams(dispatch, loadInseamPromises); // CE2-3519 ABT
    }
  };
}

export function updateProduct(data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PRODUCT,
      data,
    });
  };
}

export function setPDPContentfulData(data, productId) {
  return (dispatch) => {
    dispatch({
      type: SET_PDP_CONTENTFUL_DATA,
      productId,
      data,
    });
  };
}

export const setPDPOutfitAvailable =
  (productKey, isAvailable) => (dispatch) => {
    dispatch({
      type: SET_OUTFIT_AVAILABLE,
      productKey,
      isAvailable,
    });
  };

export const setChangeModelColorwaysMediaInfo =
  (modelInfo, modelImagery, colorwayCode) => (dispatch) => {
    dispatch({
      type: SET_CHANGE_MODEL_COLORWAYS_MEDIA_INFO,
      modelInfo,
      modelImagery,
      colorwayCode,
    });
  };

export const setTotalGiftCard = (total, isValid) => (dispatch) => {
  dispatch({
    type: SET_GIFT_CARD_TOTAL_AMOUNT,
    total,
    isValid,
  });
};

export const setGiftCardError = (message) => (dispatch) => {
  dispatch({
    type: SET_GIFT_CARD_ERROR,
    message,
  });
};
